import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './tufts-card-50.css.lit';
import headingStyle from '../tufts-heading/tufts-heading.css.lit';
import tuftsCardComponentStyle from '../tufts-card/tufts-card.css.lit';
import wysigywComponentStyle from '../tufts-styled-text/tufts-styled-text.css.lit';
import '../tufts-heading/tufts-heading';
import { tuftsCard } from '../tufts-card/tufts-card';

/**
 * The Tufts Card 50 component
 * @element tufts-card-50
 *
 * @slot media
 * @slot heading
 * @slot eyebrow
 * @slot subheading
 * @slot description
 * @slot cta-1
 * @slot cta-2
 *
 */
@customElement('tufts-card-50')
export class tuftsCard50 extends tuftsCard {
  static styles: CSSResultGroup = [
    wysigywComponentStyle,
    headingStyle,
    tuftsCardComponentStyle,
    componentStyles,
  ];
  /**
   * heading size
   */
  @property({ type: String, attribute: 'heading-size' })
  headingSize = 'xl';

  firstUpdated(): void {
    this.checkParentNodeContainer();
  }

  secondaryContentTemplate(): TemplateResult {
    return html` <div class="content">
      ${this.ngSlot.conditionalNGSlot('eyebrow')}
      ${this.ngSlot.conditionalNGSlot('heading', true, this.headingSize)}
      ${this.ngSlot.conditionalNGSlot('subheading', true, 'lg')}
      ${this.ngSlot.conditionalNGSlot('description')}
      ${this.ctaTemplate1('cta-1', this.setColorTemplate())}
      ${this.ctaTemplate2('cta-2', this.setColorTemplate())}
    </div>`;
  }

  regularOrderTemplate(): TemplateResult {
    const mediaWrapperClasses = {
      'media-content': true,
      'mobile': this.isMobile,
    };
    return html`
      <div slot="primary-content" class="${classMap(mediaWrapperClasses)}">
        ${this.ngSlot.conditionalNGSlot('media')}
      </div>
      <div slot="secondary-content">${this.secondaryContentTemplate()}</div>
    `;
  }

  /**
   * Template partial for reverse order on desktop devices
   * @returns TemplateResult
   */
  reverseOrderTemplate(): TemplateResult {
    const mediaWrapperClasses = {
      'media-content': true,
      'mobile': this.isMobile,
    };
    return html`
      <div slot="secondary-content">${this.secondaryContentTemplate()}</div>
      <div slot="primary-content" class="${classMap(mediaWrapperClasses)}">
        ${this.ngSlot.conditionalNGSlot('media')}
      </div>
    `;
  }
}
